import { ActiveCall } from "@whatslly/types/instant-messaging/WhatsappTypes";
import { IMSelectorsUnion } from "@whatslly/types/integrations/im/IMSelectorsTypes";
import { InstantMessagingService } from "@whatslly/types/instant-messaging/InstantMessagingService";

export const InjectVoiceVideoEmitter = Symbol("InjectVoiceVideoEmitter");

export type StopReturnType = { arrayBuffer: ArrayBuffer; filename: string; sampleRate: number; durationSec: number };

export interface IVoiceVideoEmitter {
  new (
    settings: Partial<IVoiceVideoEmitterSettings>,
    logger: {
      debug: (_data: any, _message: string) => void;
      warn: (data: any, message: string) => void;
      error: (data: any, message: string) => void;
    },
    instantMessagingService: InstantMessagingService
  ): IVoiceVideoEmitterInstance;
  inject(selectors: IMSelectorsUnion): boolean;
  restoreOriginalWindow(): void;
}

export interface IVoiceVideoEmitterInstance {
  [Symbol.asyncIterator](): AsyncGenerator<{ data: StopReturnType; activeCall: ActiveCall }>;
}

export interface IVoiceVideoEmitterSettings {
  abortSignal: AbortSignal;
}

export const DEFAULT_VOICE_VIDEO_EMITTER_SETTINGS = {
  abortSignal: new AbortController().signal,
} as const;
